import { atom } from "recoil";

const validationError = atom({ key: "AccountValidate", default: "" });
export { validationError };
